/**
 * Unified version for all platforms.
 *
 * Format: 2.0.{build_number}-{git_short_sha}
 * Example: 2.0.347-a3f5b2c
 *
 * The version is set by CI via:
 *   - Web: NEXT_PUBLIC_APP_VERSION env var (inlined at Next.js build time)
 *   - Desktop: package.json version (synced by scripts/sync-version.ts)
 *   - iOS: MARKETING_VERSION in xcconfig (synced by scripts/sync-version.ts)
 *   - Android: versionName in build.gradle (synced by scripts/sync-version.ts)
 *
 * Locally, falls back to "2.0.0-dev".
 */

/** Major.minor — bumped manually for major releases */
export const VERSION_BASE = "2.0";

/**
 * Full app version.
 * In CI: set via NEXT_PUBLIC_APP_VERSION (e.g. "2.0.347-a3f5b2c")
 * Locally: "2.0.0-dev"
 */
export const APP_VERSION: string =
  process.env.NEXT_PUBLIC_APP_VERSION || `${VERSION_BASE}.0-dev`;

/** Semver-clean version (no git SHA) for app stores */
export const APP_VERSION_SEMVER: string = APP_VERSION.replace(/-.*$/, "");

/** R2 bucket base URL for desktop downloads */
export const DESKTOP_UPDATES_URL = "https://desktop-updates.vidseeds.ai";

/** Download URLs use stable "latest" filenames — CI overwrites on each build */
export const DOWNLOAD_URLS = {
  mac: {
    arm64: `${DESKTOP_UPDATES_URL}/VidSeeds.ai-latest-arm64.dmg`,
    x64: `${DESKTOP_UPDATES_URL}/VidSeeds.ai-latest-x64.dmg`,
  },
  windows: `${DESKTOP_UPDATES_URL}/VidSeeds.ai-latest-setup.exe`,
  ubuntu: {
    amd64: `${DESKTOP_UPDATES_URL}/VidSeeds.ai-latest-amd64.deb`,
    arm64: `${DESKTOP_UPDATES_URL}/VidSeeds.ai-latest-arm64.deb`,
  },
} as const;

/** Canonical package id (Play listing URL is derived when env override is unset). */
export const ANDROID_PACKAGE_ID = "ai.vidseeds.android" as const;

const PLAY_STORE_LISTING_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_ID}`;

/**
 * Google Play store URL shown on /download.
 * Override with NEXT_PUBLIC_ANDROID_PLAY_STORE_URL (e.g. internal testing track).
 */
export const ANDROID_PLAY_STORE_URL: string = (
  process.env.NEXT_PUBLIC_ANDROID_PLAY_STORE_URL || PLAY_STORE_LISTING_URL
).trim();
